import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";
import { entityNameToEntity } from "../Root";



export const isEntityFetching = createSelector(
    [
        (store: StoreState) => store,
        (_, entity_name) => entity_name,
        (_, __, entity_id) => entity_id
    ],
    (store, entity_name, entity_id) => {
        const hasValue =  store?.[entityNameToEntity[entity_name]]?.valuesByEntityIdByFieldId?.[entity_id];
        if (hasValue) return false;
        
        const isFetching = store?.[entityNameToEntity[entity_name]]?._isFetching;
        return isFetching;
    }
);

export const isEntityPatching = createSelector(
    [
        (store: StoreState) => store,
        (_, entity_name) => entity_name
    ],
    (store, entity_name) => store?.[entityNameToEntity[entity_name]]?._isPatching
)


export const getRecordById = createSelector(
    (state: StoreState) => state,
    (_, record_id) => record_id,
    (state, record_id) => state.vacancies.entities?.[record_id]
        ?? state.candidates.entities?.[record_id]
        ?? state.business_units.entities?.[record_id]
        ?? state.contacts.entities?.[record_id]
        ?? state.offers.entities?.[record_id]
);

export const getValuesByEntityNameByEntityId = createSelector(
    [
        (store: StoreState) => store,
        (_, entity_name) => entity_name,
        (_, __, entity_id) => entity_id
    ],
    (store, entity_name, entity_id) => store?.[entityNameToEntity[entity_name]]?.valuesByEntityIdByFieldId?.[entity_id]
);

export const isRecordPatching = createSelector(
    [
        (store: StoreState) => store,
        (_, entity_name) => entity_name
    ],
    (store, entity_name) => store?.[entityNameToEntity[entity_name]]?._isPatching
);

export const getRecordsByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (state, entity_name) => state?.[entityNameToEntity[entity_name]]?.entities
);



export const selectRecordsByIdsByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (state, entity_name) => {
        // console.log('SELECTOR: ', state?.[entityNameToEntity[entity_name]]?.entities);
        return state?.[entityNameToEntity[entity_name]]?.entities;
    }
);

export const selectRecordsByIdByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (_, __, record_id) => record_id,
    (state, entity_name, record_id) => state?.[entityNameToEntity[entity_name]]?.entities?.[record_id]
);

export const selectValuesByIdsByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (state, entity_name) => state?.[entityNameToEntity[entity_name]]?.valuesByEntityIdByFieldId
);

export const selectValuesByIdByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (_, __, record_id) => record_id,
    (state, entity_name, record_id ) => state?.[entityNameToEntity[entity_name]]?.valuesByEntityIdByFieldId?.[record_id]
);

export const selectEntityStatisticsByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (state, entity_name) => state?.[entityNameToEntity[entity_name]]?.statistics
);

export const selectEntityPaginationByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (state, entity_name) => state?.[entityNameToEntity[entity_name]]?.pagination
);

export const isEntityCreatingByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (state, entity_name) => state?.[entityNameToEntity[entity_name]]?._isCreating
);

export const isEntityFetchingByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (state, entity_name) => state?.[entityNameToEntity[entity_name]]?._isFetching
);

export const isEntityFilteringByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (state, entity_name) => state?.[entityNameToEntity[entity_name]]?._isFiltering
);

export const selectConceptRecordIdByEntityName = createSelector(
    (state: StoreState) => state,
    (_, entity_name) => entity_name,
    (state, entity_name) => state?.[entityNameToEntity[entity_name]]?.createFlowId
)